"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomSubmit = function CustomSubmit(_ref) {
  var value = _ref.value,
      className = _ref.className,
      disabled = _ref.disabled;
  var classes = (0, _classnames.default)("custom-submit", className, {
    disabled: disabled
  });
  return /*#__PURE__*/_react.default.createElement("input", {
    type: "submit",
    value: value,
    className: classes,
    disabled: disabled
  });
};

CustomSubmit.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
CustomSubmit.defaultProps = {
  disabled: false
};
var _default = CustomSubmit;
exports.default = _default;